import * as React from 'react'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { IDevice } from '@getgreenline/homi-shared'
import { ShiftApi, ShiftModels } from '@getgreenline/shifts'
import moment from 'moment'
import { Tooltip } from 'antd'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  device: IDevice
}

interface State {
  shift?: ShiftModels.IBaseShift
  noShifts: boolean
}

@inject('currentCompanyStore', 'currentUserStore')
export class ShiftLine extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      noShifts: false,
    }
  }

  async componentDidMount() {
    const { device } = this.props
    await this.getShift(device)
  }

  getLatestShiftByDevice = async (device: IDevice): Promise<ShiftModels.IBaseShift[]> => {
    const company = this.props.currentCompanyStore!.company!
    const shiftWithLimit = await ShiftApi.getShifts(company.id, device.id, { offset: 0, limit: 1 })
    return shiftWithLimit.data
  }

  async getShift(device: IDevice) {
    const latestShift = await this.getLatestShiftByDevice(device)
    if (latestShift.length === 0) {
      this.setState({ noShifts: true })
    } else {
      this.setState({ shift: latestShift[0] })
    }
  }

  render() {
    const { shift, noShifts } = this.state
    const device = this.props.device

    return (
      <>
        {device && shift && !noShifts && (
          <tr key={device.id}>
            <td>
              <div>
                <small className='text-muted'>{device.locationName}</small>
              </div>
              <div>
                <b>{shift.deviceName}</b>
              </div>
            </td>
            <td>
              <small>{shift ? shift.currentUserName || '-' : '-'}</small>
            </td>
            <td className='text-right'>
              <Tooltip
                placement='right'
                title={
                  shift.endDate
                    ? 'Not active'
                    : `Started ${moment(shift.createDate).format('MMM DD hh:mm A')}`
                }
              >
                <span
                  className={`fa fa-circle ${shift.endDate ? 'text-warning' : 'text-success'} mr-2`}
                />
              </Tooltip>
            </td>
          </tr>
        )}
        {noShifts && (
          <tr key={device.id}>
            <td>
              <div>
                <small className='text-muted'>{device.locationName}</small>
              </div>
              <div>
                <b>{device.deviceId}</b>
              </div>
            </td>
            <td></td>
            <td className='text-right'>
              <Tooltip placement='right' title='No shifts'>
                <span className={`fa fa-circle text-warning mr-2`} />
              </Tooltip>
            </td>
          </tr>
        )}
      </>
    )
  }
}
